import React, { Component } from 'react';


import {
    Container,
    Row,
    Col,
    Jumbotron,
    Button
  } from 'reactstrap';

import './MainArea.css';
import MonsterContainer from "./MonsterContainer";
import BossContainer from "./BossContainer";

// import {MONSTERS, BOSS_STATS} from '../lib/monsters/index';
import './MonsterContainer.css';

// import {SCENARIO_DEFINITIONS} from '../lib/scenarioList';

// console.log(MONSTERS);
// console.log(BOSS_STATS);
// console.log(BOSS_STATS["The Colorless"][3](4));

// console.log(MONSTERS["Harrower Infester"].stats[5].elite)
// console.log(SCENARIO_DEFINITIONS);


class MainArea extends Component {


    render() {



        return (
        <div style={{paddingTop:"10px"}}>
            {!this.props.scenarioLoaded ? 
                <Container>
                    <Jumbotron>
                        <h1 className="display-3" style={{ fontFamily: "PirataOne" }}>Gloomhaven Monster Tracker</h1>
                        <p className="lead" style={{ fontFamily: "HighTower" }}>This app replaces the monster stat cards and damage/status tokens for the monsters.</p>
                        <hr className="my-2" />
                        <p style={{ fontFamily: "HighTower" }}>Load a scenario, or add monsters to get started!</p>
                        <p className="lead">
                            <Button color="primary" onClick={this.props.toggleSidebar}>Open Menu</Button>
                        </p>
                    </Jumbotron>
                </Container>
                :
                null
            }
            
            
            {/* for ease of testing */}
            <Container fluid>
                {/* {!this.props.scenarioLoaded ? (
                    <div>
                    <Row>
                        <Col md="12">
                            <MonsterContainer monsterType={"Harrower Infester"} level={6} />
                        </Col>

                    </Row>
                    <Row>
                        <Col md="12">
                            <MonsterContainer monsterType={"Living Bones"} level={6} />
                        </Col>

                    </Row>
                    </div>
                ):(
                  <div></div>  
                )} */}

                
                {this.props.monstersObjList != null ? (
                    this.props.monstersObjList.map((monster) => {
                        if(monster.monsterType.includes("Boss") === false){
                            return(
                                <Row key= { monster.monsterType }>
                                    <Col md="12" >
                                        <MonsterContainer  monsterType={monster.monsterType} level={monster.monsterLevel} removeMonster={this.props.removeMonster}/>
                                    </Col>
                                </Row>
                            )
                        } else {
                            return(
                                <Row key={monster.monsterType.replace("Boss: ","")}>
                                    <Col md="12" >
                                        <BossContainer monsterType={monster.monsterType.replace("Boss: ","")} level={monster.monsterLevel} removeMonster={this.props.removeMonster} />
                                    </Col>
                                </Row>
                            );
                        }
                    })
                ) : null}

            </Container>

        </div>
        );
    }
}


export default MainArea;


// WEBPACK FOOTER //
// ./src/components/MainArea.js